import axios from "axios";
import { api } from "../config";

// Set default content type
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.baseURL = api.API_URL;

// Request interceptor to add token to every request
axios.interceptors.request.use(
  (config) => {
    // Get token from localStorage (primary) or sessionStorage (fallback)
    const token = localStorage.getItem("token") || 
                  (sessionStorage.getItem("authUser") ? 
                   JSON.parse(sessionStorage.getItem("authUser")).token : null);
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors globally
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message = error.response.data?.message || "Bad Request";
          break;
        case 401:
          message = error.response.data?.message || "Unauthorized - Please login again";
          // Auto logout on 401
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          sessionStorage.removeItem("authUser");
          // Redirect to login if not already there
          if (window.location.pathname !== "/login") {
            window.location.href = "/login";
          }
          break;
        case 403:
          message = error.response.data?.message || "Forbidden - You don't have permission";
          break;
        case 404:
          message = error.response.data?.message || "Resource not found";
          break;
        case 409:
          message = error.response.data?.message || "Conflict - Record already exists";
          break;
        case 422:
          message = error.response.data?.message || "Validation failed";
          break;
        case 500:
          message = error.response.data?.message || "Internal Server Error";
          break;
        case 503:
          message = "Service temporarily unavailable";
          break;
        default:
          message = error.response.data?.message || error.message || "An error occurred";
      }
    } else if (error.request) {
      message = "Network error - Please check your connection";
    } else {
      message = error.message || "An error occurred";
    }
    
    return Promise.reject({ ...error, message });
  }
);

/**
 * Sets the default authorization token
 * @param {string} token - JWT token
 */
const setAuthorization = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("token", token);
  } else {
    delete axios.defaults.headers.common["Authorization"];
    localStorage.removeItem("token");
  }
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };